import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';

export const CommunityGalleryWrapper = styled.div`
    && {
        background-color: ${(p) => p.theme.palette.neutral.charcoal};
        ${(p) => p.theme.breakpoints.up('sm')} {
        }
        h2,
        a .tertiary {
            color: ${(p) => p.theme.palette.common.white};
        }
        .ue-outlined.ue-link-wrap:focus-visible {
            button.tertiary {
                outline: 1px solid ${(p) => p.theme.palette.neutral.pearl};
                outline-offset: 2px;
            }
        }
    }
`;

export const SliderWrapper = styled.div<{accentcolor: AccentColorOptions}>`
    && {
        ${(p) => p.theme.breakpoints.up('md')} {
            display: flex;
        }
        .slick-list {
            ${(p) => p.theme.breakpoints.up('xs')} {
                margin-bottom: ${(p) => p.theme.spacing(2)}px;
                width: 100vw;
                left: -${(p) => p.theme.spacing(2)}px;
                padding-left: ${(p) => p.theme.spacing(2)}px;
            }
            ${(p) => p.theme.breakpoints.up('sm')} {
                width: 100vw;
                left: -${(p) => p.theme.spacing(3)}px;
                padding-left: ${(p) => p.theme.spacing(3)}px;
            }
            ${(p) => p.theme.breakpoints.up('md')} {
                width: 100%;
                max-width: ${(p) => p.theme.spacing(55)}px;
            }
        }
        .slick-track {
            display: flex;
        }
        .slick-slide {
            display: flex;
            height: auto;
            ${(p) => p.theme.breakpoints.up('xs')} {
                width: calc(100vw - ${(p) => p.theme.spacing(4)}px);
            }
            ${(p) => p.theme.breakpoints.up('sm')} {
                width: calc(100vw - ${(p) => p.theme.spacing(6)}px);
            }
            ${(p) => p.theme.breakpoints.up('md')} {
                width: 100%;
            }
        }
        .slick-dots {
            bottom: auto;
            li {
                margin: 0 2px;
                button {
                    &:before {
                        font-size: 10px;
                        color: ${(p) => p.theme.palette.neutral.stone};
                        opacity: 0.6;
                        transition: color 0.25s ${(p) => p.theme.easing};
                        transition: opacity 0.25s ${(p) => p.theme.easing};
                    }
                    &:hover {
                        &:before {
                            opacity: 1;
                            transition: color 0.25s ${(p) => p.theme.easing};
                            transition: opacity 0.25s ${(p) => p.theme.easing};
                        }
                    }
                    &:focus-visible {
                        outline: 1px solid ${(p) => p.theme.palette.neutral.pearl};
                        outline-offset: 2px;
                    }
                }
            }
            li.slick-active button:before {
                color: ${(p) => p.theme.palette.accent[p.accentcolor]};
                opacity: 1;
                transition: color 0.25s ${(p) => p.theme.easing};
                transition: opacity 0.25s ${(p) => p.theme.easing};
            }
        }
    }
`;
